import { Select } from '@plaidev/sour-react';
import type { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useColumnEditor } from '../context/ColumnEditorContext';
import type { FormValues } from '../types';

export function ConfigureContractUkSection(): ReactElement {
  const { control } = useFormContext<FormValues>();
  const { contractColumnNames } = useColumnEditor();

  return (
    <section className="flex flex-col gap-3 rounded-lg border border-default p-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-sm font-semibold text-default">
          一意キー（契約）<span className="text-negative">*</span>
        </h2>
        <p className="text-xs text-muted-light">「契約」にマップした列から、レコードを一意に識別するキーを 1 つ以上選択してください。</p>
      </div>
      {contractColumnNames.length === 0 ? (
        <p className="text-sm text-negative">「契約」にマップされている列がありません。先に上の表で振り分けを行ってください。</p>
      ) : (
        <Controller
          control={control}
          name="contractUkColumns"
          render={({ field }) => (
            <Select
              multiple
              variant="contained"
              placeholder="契約の一意キーを選択"
              options={contractColumnNames.map((n) => ({ value: n, label: n }))}
              value={field.value}
              onChange={(v) => field.onChange(Array.isArray(v) ? (v as string[]) : [])}
            />
          )}
        />
      )}
    </section>
  );
}
